interface ISearchForm {
  input: HTMLInputElement;
  form: HTMLDivElement;
}

const MAX_SEARCH_LENGTH = 80;

function getHid(el: HTMLInputElement): string {
  if (el.classList.contains("getHid")) {
    return el.dataset["hid"] ?? "";
  }
  return "";
}

function buildSearchUrl(hid: string, keyword: string): string {
  const params = new URLSearchParams();
  if (hid) params.set("hid", hid);
  params.set("q", keyword);
  return `/SearchResult.aspx?${params.toString()}`;
}

const searchForProducts = (searchForm: ISearchForm) => {
  const hid: string = getHid(searchForm.input); //get hid, if exists (For landing pages created via templates);
  let keyword = (searchForm.input.value || "").trim(); //get keyword
  if (keyword.length > MAX_SEARCH_LENGTH) {
    keyword = keyword.substring(0, MAX_SEARCH_LENGTH);
  }
  // don't search empty strings
  if (!keyword) return;
  location.href = buildSearchUrl(hid, keyword);
};

const setupEventHandlers = (searchForm: ISearchForm) => {
  if (!searchForm?.input || !searchForm?.form) return;

  searchForm.input.addEventListener("focus", () => {
    if (searchForm.input.value === searchForm.input.defaultValue) {
      searchForm.input.value = "";
    }
  });

  searchForm.input.addEventListener("keydown", (ev) => {
    if (ev.key === "Enter") {
      ev.preventDefault();
      searchForProducts(searchForm);
    }
  });

  const submitButtons = searchForm.form.getElementsByClassName("submit");

  for (let i = 0; i < submitButtons.length; i++) {
    submitButtons[i].addEventListener("click", () => {
      searchForProducts(searchForm);
    });
  }
};

const getActiveSearchForm: () => ISearchForm | null = () => {
  const customSearchInput = document.getElementById(
    "h-search-custom",
  ) as HTMLInputElement | null;

  const defaultSearchInput = document.getElementById(
    "h-search",
  ) as HTMLInputElement | null;

  const input = customSearchInput ?? defaultSearchInput;
  if (!input) return null;

  // Prefer the closest form container to the input if possible
  const form = input.closest(".search-form") as HTMLDivElement | null;
  if (form) return { input, form };

  // Fallback to first .search-form
  const forms = document.getElementsByClassName(
    "search-form",
  ) as HTMLCollectionOf<HTMLDivElement>;
  if (forms.length > 0) return { input, form: forms[0] };

  return null;
};

export function setupProductSearch() {
  const searchLink = document.getElementById("search") as HTMLElement,
    searchLinkMenu = document.getElementById("searchlink-menu") as HTMLElement;

  if (searchLink) {
    searchLink.addEventListener("click", () => {
      const searchForm = getActiveSearchForm();
      if (!searchForm) return;

      // triggered by the search icon in the mobile header.
      // On click, prepend the search-form to topblock i.e before logo
      // and show the search bar that already exists

      const topBlock = document.querySelector(".top-block");
      if (topBlock) topBlock.prepend(searchForm.form);
      searchForm.form.style.display = "flex";
      searchForm.form.style.flexDirection = "column";
      searchForm.input.focus();
    });

    //hide the search link if there is no search form.
    if (!getActiveSearchForm()) {
      if (searchLink) searchLink.style.display = "none";
      if (searchLinkMenu) searchLinkMenu.style.display = "none";
    }
  }

  // attach event handler to close search button
  document.querySelectorAll(".close-search").forEach((el) => {
    el.addEventListener("click", () => {
      const searchForm = getActiveSearchForm();
      if (searchForm?.form) {
        searchForm.form.style.display = "none";
      }
    });
  });

  const searchForm = getActiveSearchForm();
  if (searchForm) {
    setupEventHandlers(searchForm);
  }
}
